import React from 'react';
import Cleave from 'cleave.js/react';

export interface PhoneNumberInputProps extends React.HTMLAttributes<HTMLInputElement> {
    value?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
    className,
    value,
    onChange,
    ...props
}) => {
    return (
        <Cleave
            {...props}
            placeholder="0000000000"
            options={{
                blocks: [14],
                numericOnly: true,
            }}
            value={value}
            onChange={onChange}
            className={className}
        />
    );
};

export default PhoneNumberInput;
